import React, { useState } from "react";
import { Row, Col, Modal, ModalHeader, ModalBody, Label } from "reactstrap";
import { SuccessOk } from "configs/statusCode";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import SalesRepsService from "services/Provider/SalesRepServices";

function ModalForm({ modal, toggle, salesRep }) {
	const [loading, setLoading] = useState(false);
	const [currentPassword, setCurrentPassword] = useState(true);
	const [password, setPassword] = useState(true);
	const [confirmPassword, setConfirmPassword] = useState(true);
	const [formState, setFormState] = useState({
		new_password: "",
		current_password: "",
		password_confirmation: "",
	});
	const salesRepsService = new SalesRepsService();

	const handleFieldChange = (e) => {
		setFormState({ ...formState, [e.target.name]: e.target.value });
	};

	const handleValidSubmit = (e, values) => {
		if (formState.new_password !== formState.password_confirmation) {
			toast.error("New Password Confirmation doesnot match Password");
			return;
		} else {
			setLoading(true);
			const data = {
				current_password: formState.current_password,
				password: formState.new_password,
				password_confirmation: formState.password_confirmation,
				name: salesRep.name,
				email: salesRep.email,
			};

			salesRepsService
				.update(data)
				.then((res) => {
					if (res && res.status === SuccessOk) {
						toggle();
						toast.success("Password changed successfully");
					} else {
						toast.error(res);
					}
					setLoading(false);
				})
				.catch((e) => setLoading(false));
		}
	};
	return (
		<Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
			<ModalHeader className="border-0" toggle={toggle}>
				Change Password
			</ModalHeader>
			<ModalBody className="pt-0">
				<AvForm
					className="form-horizontal formWithLabel"
					onValidSubmit={(e, v) => {
						handleValidSubmit(e, v);
					}}>
					<Row>
						<Col md={12} className="position-relative">
							<Label>Current Password</Label>
							<AvField
								className="mb-3 font-size-14"
								name="current_password"
								bsSize="lg"
								required
								placeholder="Type Password"
								value={formState.current_password}
								onChange={(e) => handleFieldChange(e)}
								type={currentPassword ? "password" : "text"}
							/>
							<div
								style={{
									position: "absolute",
									top: "40px",
									right: "25px",
								}}
								onClick={() => setCurrentPassword((c) => !c)}>
								{formState.current_password.trim().length !== 0 ? (
									currentPassword ? (
										<i className="fas fa-eye-slash"></i>
									) : (
										<i className="fas fa-eye  "></i>
									)
								) : null}
							</div>
						</Col>
						<Col md={12} className="position-relative">
							<Label>New Password</Label>
							<AvField
								className="mb-3 font-size-14"
								name="new_password"
								bsSize="lg"
								required
								placeholder="Type Password"
								value={formState.new_password}
								onChange={(e) => handleFieldChange(e)}
								type={password ? "password" : "text"}
							/>
							<div
								style={{
									position: "absolute",
									top: "40px",
									right: "25px",
								}}
								onClick={() => setPassword((c) => !c)}>
								{formState.new_password.trim().length !== 0 ? (
									password ? (
										<i className="fas fa-eye-slash"></i>
									) : (
										<i className="fas fa-eye  "></i>
									)
								) : null}
							</div>
						</Col>
						<Col md={12} className="position-relative">
							<Label>Password Confirmation</Label>
							<AvField
								className="mb-3 font-size-14"
								name="password_confirmation"
								bsSize="lg"
								required
								placeholder="Type Password"
								value={formState.password_confirmation}
								onChange={(e) => handleFieldChange(e)}
								type={confirmPassword ? "password" : "text"}
							/>
							<div
								style={{
									position: "absolute",
									top: "40px",
									right: "25px",
								}}
								onClick={() => setConfirmPassword((c) => !c)}>
								{formState.password_confirmation.trim().length !== 0 ? (
									confirmPassword ? (
										<i className="fas fa-eye-slash"></i>
									) : (
										<i className="fas fa-eye  "></i>
									)
								) : null}
							</div>
						</Col>
					</Row>
					<Row className="p-0 pt-1 m-0 mt-2 d-flex justify-content-between">
						<Col md={6} className="p-0">
							<button
								type="button"
								onClick={toggle}
								className="btn btn-secondary w-50 ">
								Cancel
							</button>
						</Col>
						<Col md={6} className="p-0 d-flex justify-content-end">
							<button
								type="submit"
								disabled={loading ? true : false}
								className="btn btn-success w-50">
								Submit
							</button>
						</Col>
					</Row>
				</AvForm>
			</ModalBody>
		</Modal>
	);
}

export default ModalForm;
